module.exports = __webpack_public_path__ + "r-v3/img/sticker_24.db37330d.svg";